import {
  WithUiKitTypographyVariants,
  withUiKitTypographyVariants,
} from 'style-utils/withStyledProps/withUiKitTypographyVariants';
import styled, { StyledProps } from 'styled-components';
import {
  WithLayoutProps,
  withLayout,
} from 'style-utils/withStyledProps/withLayoutProps';
import {
  WithTypographyProps,
  withOneLineEllipsis,
  withTypography,
} from 'style-utils/withStyledProps/withTypographyProps';

export type CommonTextProps = Omit<
  StyledProps<
    WithTypographyProps & WithUiKitTypographyVariants & WithLayoutProps
  >,
  'color' | 'theme'
> & {
  ellipsis?: boolean;
  lineClamp?: boolean;
};
export const Text = styled.span<CommonTextProps>`
  ${withLayout}
  ${withUiKitTypographyVariants}
  ${withTypography};
  ${({ ellipsis }) => ellipsis && withOneLineEllipsis};
  ${({ lineClamp }) =>
    lineClamp &&
    `-webkit-box-orient: vertical;
    -webkit-line-clamp: ${lineClamp};`};
  display: ${(props) => props.d || 'block'};
`;

Text.displayName = 'Text';
Text.defaultProps = {
  textColor: 'textPrimary',
};
